import React, { useEffect, useState } from 'react';
import { ReactComponent as AdvertenciaTriangulo } from 'assets/icons/warningtriangle.svg';
import "../../assets/scss/Horas Extras/HorasExtras.scss"


export type PropsAlertEstado = {
    estadoPlanificacion: string;
    oncloseElement: () => void;
    closeButton?: boolean;
    tipo?: string
    className?: string
};

const AlertEstadoHE: React.FC<PropsAlertEstado> = (props) => {
    const [classNameAlerta, setClassNameAlerta] = useState<string>('');
    const [classNameIcono, setClassNameIcono] = useState<string>('');
    const [mensaje, setMensaje] = useState<string>('');
    const [mensajeInicio, setMensajeInicio] = useState<string>('');

    useEffect(() => {
        switch (props.estadoPlanificacion) {
            case '':
                setClassNameAlerta('alert-no-enviado');
                setClassNameIcono('fa fa-exclamation-triangle')
                setMensaje('No Enviado a TH');
                break;
            case 'MO':
                setClassNameAlerta('alert-no-enviado');
                setClassNameIcono('fa fa-exclamation-triangle')
                setMensaje('No Enviado a TH');
                break;
            case 'ET':
                setClassNameAlerta('alert-enviado-th');
                setClassNameIcono('fa fa-paper-plane')
                setMensaje('Enviado a TH');
                break;
            case 'RT':
                setClassNameAlerta('alert-reversado-th');
                setClassNameIcono('fa fa-undo-alt')
                setMensaje('Reversado por TH');
                break;
            case 'RE':
                setClassNameAlerta('alert-reversado-th');
                setClassNameIcono('fa fa-undo-alt')
                setMensaje('Reversado por TH');
                break;
            case 'SR':
                setClassNameAlerta('alert-solicitado-reverso');
                setClassNameIcono('fa fa-undo-alt')
                if(props.tipo === 'PR' ){
                    setMensaje('Solicitado Reverso de la Proyección');
                }
                else {
                    setMensaje('Solicitado Reverso');
                }
                
                break;
            case 'EG':
                setClassNameAlerta('alert-enviado-gpe');
                setClassNameIcono('fa fa-paper-plane')
                setMensaje('Enviado a GPE');
                break;
            case 'RG':
                setClassNameAlerta('alert-reversado-gpe');
                setClassNameIcono('fa fa-undo-alt')
                setMensaje('Reversado por GPE');
                break;
            case 'AP':
                setClassNameAlerta('alert-presupuesto-asignado');
                setClassNameIcono('fa fa-money-bill')
                setMensaje('Pesupuesto Asignado');
                break;
            default:
                setClassNameAlerta('alert-default');
                setClassNameIcono('fa fa-question-circle')
                setMensaje('Estado desconocido');
                break;
        }
    }, [props.estadoPlanificacion,props.tipo]);

    useEffect(() => {
        switch (props.tipo) {
            case 'PR':
                setMensajeInicio(' Estado Proyección: ');
                break;
            case 'PL':
                setMensajeInicio(' Estado Planificación: ');
                break;
            default:
                setMensajeInicio(' Estado: ');
                break;
        }
    }, [props.estadoPlanificacion]);

    return (
        <div className={`alert-estado ${props.className} ${classNameAlerta}`}>
            {props.closeButton !== false && <a className="close-alert" onClick={props.oncloseElement}>&times;</a>}
            <div className="alert-message">
                <i className={` icono-estado ${classNameIcono}`}></i> {mensajeInicio} {mensaje}
            </div>
        </div>
    );
};

export default AlertEstadoHE;
